import React, {createContext, useReducer} from 'react'
import {AdtaDeviceOverviewReducer} from "../reducer/AdtaDeviceOverviewReducer";

export const AdtaDeviceOverviewContext = createContext();

const AdtaDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        adtaDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(AdtaDeviceOverviewReducer, data)
    return (
        <AdtaDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AdtaDeviceOverviewContext.Provider>
    )
}

export default AdtaDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtadevice/context/AdtaDeviceOverviewContext.js